import { render, staticRenderFns } from "./HistoricoPagamentosPublicados.vue?vue&type=template&id=3b38254a"
import script from "./HistoricoPagamentosPublicados.vue?vue&type=script&lang=js"
export * from "./HistoricoPagamentosPublicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports